import * as React from "react";
const Subscribe = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="#fff"
      d="m6.58 15.25.92-3.89-3-2.58 3.95-.37L10 4.8l1.55 3.65 3.95.33-3 2.58.92 3.89L10 13.19l-3.42 2.06ZM10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
    />
  </svg>
);
export default Subscribe;
